import { createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../../services/instance";
import { endpoints } from "../../constants/endpoints";

export const getAuthUser = createAsyncThunk("getAuthUser", async (id) => {
  try {
    const response = await instance.get(endpoints.getAuthUser(id));
    return response;
  } catch (error) {
    return {
      exception: error,
    };
  }
});
